import React from 'react';
import { graphql, navigate } from 'gatsby';
import { RichText } from 'prismic-reactjs';

import { Spacer } from '@styles';
import * as ROUTES from '@utils/routes';

import PageHeader from '@common/PageHeader';
import Login from '@components/global/Login';

const RenderBody = ({ home }) => {
  const title = home.title;
  const subtitle = home.subtitle;
  const icon = home.icon;

  return (
    <>
      <PageHeader
        title={RichText.asText(title)}
        subtitle={RichText.asText(subtitle)}
        imageUrl={icon.url}
        imageAlt={icon.alt}
      />
      <Spacer break2 />
      <Login />
    </>
  );
};

export default ({ data }) => {
  const doc = data.prismic.allLogins.edges.slice(0, 1).pop();

  if (!doc) return null;
  if (typeof window !== 'undefined') {
    if (!localStorage.getItem('authUser')) {
      return <RenderBody home={doc.node} />;
    } else {
      navigate(ROUTES.APP_PROFILE);
      return null;
    }
  } else {
    return null;
  }
};

export const query = graphql`
  {
    prismic {
      allLogins {
        edges {
          node {
            icon
            title
            subtitle
          }
        }
      }
    }
  }
`;
